import { tickerItems } from "@/mocks/home";

export default function NewsTicker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <section className="w-full bg-foreground-950">
      <div className="mx-auto flex max-w-[1280px] items-stretch gap-0">
        <div className="flex shrink-0 items-center gap-2 bg-primary-500 px-4 text-sm font-medium text-background-50 md:px-6">
          <i className="ri-flashlight-fill" />
          <span className="whitespace-nowrap">新料速递</span>
        </div>
        <div className="relative flex-1 overflow-hidden py-3.5">
          <div className="flex w-max animate-marquee items-center whitespace-nowrap">
            {loop.map((item, index) => (
              <span key={`${item.text}-${index}`} className="flex items-center text-sm text-background-100">
                <span>{item.text}</span>
                <span className="mx-2 text-xs text-accent-300">{item.time}</span>
                <span className="mx-3 text-background-500">/</span>
              </span>
            ))}
          </div>
          <div className="pointer-events-none absolute inset-y-0 left-0 w-10 bg-gradient-to-r from-foreground-950 to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-foreground-950 to-transparent" />
        </div>
      </div>
    </section>
  );
}